import React, { useContext, useEffect } from "react";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { AuthContext } from "../../../contexts/AuthContext";
import logo from "../../../assets/logo-dark.svg";
import { Button } from "../../../components/button";

function Logout() {
  const { login } = useKindeAuth();
  const { authContext, resetAuthContext } = useContext(AuthContext); // Access auth context
  const authOrgId = authContext?.organization?.authOrgId || ""; // Keep org ID for login

  // Reset auth context when logout page loads
  useEffect(() => {
    resetAuthContext();
  }, [resetAuthContext]);

  return (
    <div className="flex h-screen justify-center items-center bg-black">
      <div className="sm:px-12 lg:px-24 sm:py-8 lg:py-16 rounded-lg bg-white flex rounded-large items-center justify-center flex-col">
        <img src={logo} alt="Opspot" />
        <div className="leading-relaxed pt-12 w-full text-center">
          You have been logged out.
        </div>
        <div className="pt-10">
          <Button
            onClick={() =>
              login({
                org_code: authOrgId, // Use stored org code for login
                app_state: {
                  redirectTo: "/", // Redirect back to home after login
                },
              })
            }
          >
            Log back in
          </Button>
        </div>
      </div>
    </div>
  );
}

export { Logout };
